( function( app ) {
  const COMPONENT = {
    init() {
      const cards = [...document.querySelectorAll( '.js-service-card' )];
      const coarsePointer = window.matchMedia( '(hover: none), (pointer: coarse)' );
      const EXIT_DELAY = 200;

      cards.forEach( ( card ) => {
        let activatedFromPointer = false;
        let exitTimer = null;

        const setActive = ( active ) => {
          clearTimeout( exitTimer );
          card.classList.remove( 'is-exiting' );
          card.classList.toggle( 'is-active', active );
        };

        const exitActive = () => {
          clearTimeout( exitTimer );

          if ( !card.classList.contains( 'is-active' ) ) return;

          card.classList.add( 'is-exiting' );

          exitTimer = setTimeout( () => {
            card.classList.remove( 'is-active', 'is-exiting' );
          }, EXIT_DELAY );
        };

        const activateOnlyThisCard = () => {
          clearTimeout( exitTimer );
          card.classList.remove( 'is-exiting' );

          cards.forEach( ( currentCard ) => {
            if ( currentCard !== card ) {
              currentCard.classList.remove( 'is-exiting' );
            }

            currentCard.classList.toggle( 'is-active', currentCard === card );
          } );
        };

        card.addEventListener( 'pointerenter', ( event ) => {
          if ( event.pointerType === 'touch' || coarsePointer.matches ) return;

          setActive( true );
        } );

        card.addEventListener( 'pointerleave', ( event ) => {
          if ( event.pointerType === 'touch' || coarsePointer.matches ) return;

          exitActive();
        } );

        card.addEventListener( 'focusin', () => {
          setActive( true );
        } );

        card.addEventListener( 'focusout', ( event ) => {
          if ( card.contains( event.relatedTarget ) ) return;

          exitActive();
        } );

        card.addEventListener( 'pointerdown', ( event ) => {
          if ( event.pointerType !== 'touch' && !coarsePointer.matches ) return;

          activatedFromPointer = false;

          if ( !card.classList.contains( 'is-active' ) ) {
            activatedFromPointer = true;
            activateOnlyThisCard();
          }
        } );

        card.addEventListener( 'click', ( event ) => {
          if ( !coarsePointer.matches ) return;

          if ( activatedFromPointer ) {
            activatedFromPointer = false;
            event.preventDefault();
            return;
          }

          if ( card.classList.contains( 'is-active' ) ) return;

          event.preventDefault();
          activateOnlyThisCard();
        } );
      } );

      document.addEventListener( 'pointerdown', ( event ) => {
        if ( !coarsePointer.matches ) return;
        if ( cards.some( ( card ) => card.contains( event.target ) ) ) return;

        cards.forEach( ( card ) => {
          card.classList.remove( 'is-active', 'is-exiting' );
        } );
      } );
    },
    finalize() {},
  };
  app.registerComponent( 'service-pathways', COMPONENT );
} )( app );
